import React from 'react'
import { Button } from '~/components/common/Button'
import { List, ListColumn } from '~/components/common/List'
import { Typography } from '~/components/common/Typography'
import { UploadedRepo } from './types'

interface UploadedReposListProps {
  uploadedRepos: UploadedRepo[]
  onRemove: (id: number) => void
  title?: string
  className?: string
}

export const UploadedReposList: React.FC<UploadedReposListProps> = ({
  uploadedRepos,
  onRemove,
  title = 'Uploaded Repos',
  className = ''
}) => {
  if (uploadedRepos.length === 0) return null

  const columns: ListColumn[] = [
    { label: 'Repository', flex: 1, align: 'left' },
    { label: '', width: '48px', align: 'right' }
  ]

  const values = uploadedRepos.map(repo => [
    <div key={`repo-${repo.id}`} className='flex flex-col gap-1 min-w-0'>
      <Typography
        fontFamily='geist'
        fontSize='bodyMdMedium'
        fontWeight='medium'
        className='text-tokens-neutral-text-primary truncate'
      >
        {repo.name}
      </Typography>
      <Typography
        fontFamily='geistMono'
        fontSize='labelSm'
        fontWeight='semibold'
        className='text-tokens-neutral-text-tertiary'
      >
        {repo.size}
      </Typography>
    </div>,
    <Button
      variant='borderless'
      className='flex w-[36px] h-[36px] p-0 hover:rounded-[8px]'
      key={`actions-${repo.id}`}
      onClick={() => onRemove(repo.id)}
    >
      <svg
        width='20'
        height='20'
        viewBox='0 0 20 20'
        fill='none'
        className='w-5 h-5 text-tokens-neutral-icon-default'
      >
        <path
          d='M7.03125 3.59375H6.875C6.96094 3.59375 7.03125 3.52344 7.03125 3.4375V3.59375H12.9688V3.4375C12.9688 3.52344 13.0391 3.59375 13.125 3.59375H12.9688V5H14.375V3.4375C14.375 2.74805 13.8145 2.1875 13.125 2.1875H6.875C6.18555 2.1875 5.625 2.74805 5.625 3.4375V5H7.03125V3.59375ZM16.875 5H3.125C2.7793 5 2.5 5.2793 2.5 5.625V6.25C2.5 6.33594 2.57031 6.40625 2.65625 6.40625H3.83594L4.31836 16.6211C4.34961 17.2871 4.90039 17.8125 5.56641 17.8125H14.4336C15.1016 17.8125 15.6504 17.2891 15.6816 16.6211L16.1641 6.40625H17.3438C17.4297 6.40625 17.5 6.33594 17.5 6.25V5.625C17.5 5.2793 17.2207 5 16.875 5ZM14.2832 16.4062H5.7168L5.24414 6.40625H14.7559L14.2832 16.4062Z'
          fill='black'
          fillOpacity='0.45'
        />
      </svg>
    </Button>
  ])

  return (
    <div data-testid='uploaded-repos' className={`flex flex-col gap-4 w-full mt-4 ${className}`}>
      <div className='px-4'>
        <Typography
          fontFamily='geistMono'
          fontSize='labelMd'
          fontWeight='semibold'
          className='text-tokens-neutral-text-secondary'
        >
          {title}
        </Typography>
      </div>
      <List columns={columns} values={values} headerClassName='hidden' />
    </div>
  )
}
